import React, { Dispatch, SetStateAction } from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';

import { UseOutletContextAccounting } from '../Accounting';
import { Company } from '../../../../models/company.model';
import { Settings } from '../../../../models/settings.model';

export interface StatementPageProps {};

type ContexType = {
  setRoute: Dispatch<SetStateAction<{path: {root: string, branch: string} | null, company: boolean} | null>>,
  companyForUser: Company | null,
  settingsForCompany: Settings | null
};

const StatementPage: React.FunctionComponent<StatementPageProps> = props => {
  const {setRoute, companyForUser, settingsForCompany} = UseOutletContextAccounting()

  return (
    <Outlet context={{setRoute, companyForUser, settingsForCompany}}></Outlet>
  );
}

export function UseOutletContextStatement() {
  return useOutletContext<ContexType>()
};

export default StatementPage;
